// src/redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import supportportalLoginReducer from './supportportalLoginSlice';
import userSlice from './userSlice';
import createUserReducer from './createUserSlice';
import roleReducer from './roleSlice';
import digitalPriceReducer from './digitalPriceSlice';
import passwordResetReducer from './passwordResetSlice';
import digitalPriceExcelReducer from './digitalPriceExcelSlice'; // 引入新的 reducer

const store = configureStore({
  reducer: {
    supportportalLogin: supportportalLoginReducer,
    users: userSlice,
    createUser: createUserReducer,
    roles: roleReducer,
    digitalPrice: digitalPriceReducer,
    passwordReset: passwordResetReducer,
    digitalPriceExcel: digitalPriceExcelReducer // 添加新的 reducer
  }
});

export default store;